import { Component, OnInit } from '@angular/core';

import { Platform, MenuController, AlertController } from '@ionic/angular';
import { ElectronRef } from './shared/electron-ref';
import { AuthService } from './services/auth.service';

import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { TranslateConfigService } from './services/translate-config.service';
import { Storage } from '@ionic/storage';
import { Events } from './services/events.service';
declare var app: any;
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  public isAuthenticated = false;
  public selectedIndex = 0;
  user: any = null;
  real_user: any = null;
  public appPages = [
    {
      title: 'Alertes pollutions',
      url: '/dashboard',
      icon: 'home',
      badge: 0,
    },
    {
      title: 'Carte',
      url: '/map',
      icon: 'map',
      badge: 0,
    },
    {
      title: 'Alertes zone urbaine',
      url: '/urbaine',
      icon: 'business',
      badge: 0,
      role: 3,
    },
    {
      title: 'Alertes assainissement',
      url: '/assainissements',
      icon: 'water',
      badge: 0,
    },
    {
      title: 'Avis de recherche',
      url: '/avis',
      icon: 'flashlight',
      badge: 0,
      role: 3,
    },
    {
      title: 'Climat',
      url: '/climat',
      icon: 'earth',
      badge: 0,
      role: 3,
    },
    {
      title: 'Statistiques',
      url: '/stats',
      icon: 'stats-chart',
      badge: 0,
    },
    {
      title: 'Utilisateurs',
      url: '/users',
      icon: 'people',
      role: 3,
      badge: 0,
    },
    {
      title: 'Communes',
      url: '/communes',
      icon: 'pricetag',
      role: 3,
      badge: 0,
    },
    {
      title: 'Agglomérations',
      url: '/agglomerations',
      icon: 'pricetags',
      role: 3,
      badge: 0,
    },
  ];
  public labels = ['Urgent', 'Déchets', 'Pollution'];

  constructor(
    private electronRef: ElectronRef,
    public menu: MenuController,
    private platform: Platform,
    private authService: AuthService,
    public storage: Storage,
    private alertCtrl: AlertController,
    private router: Router,
    private translateConfigService: TranslateConfigService,
    public afAuth: AngularFireAuth,
    private events: Events
  ) {
    this.initializeApp();


    this.events.subscribe('badge', (data) => {
      // console.log("data", data);
      for (let page of this.appPages) {
        if (page.url == data.url) {
          page.badge = data.badge_count;
          break;
        }
      }
    });

    this.events.subscribe('real_user', (data) => {
      this.real_user = data;
      console.log("real_user subscribe", data);
    });
  }


  stopimpersonate() {
    this.authService.impersonate = false;
    this.authService.setUser(this.real_user);
    this.user = this.real_user;
    
    this.router.navigate(["/dashboard"]);
  }


  logout() {
    this.authService.doLogout();
  }

  async initializeApp() {


    let lang = await this.translateConfigService.initLang();

    this.translateConfigService.setLanguage(lang);
    this.platform.ready().then(() => {
      this.afAuth.user.subscribe(async user => {
        console.log("afAuth.user", user)
        if (user && user.uid) {
          this.authService.setLoggedIn(true);
          let check = await this.authService.setUser(user);
          console.log("check", {check, user})
          if (check >= 2) {
            this.router.navigate(["/dashboard"]);
            this.isAuthenticated = true;
            this.menu.enable(true);
            this.user = this.authService.getUser();
            this.real_user = this.authService.getUser(false);
            console.log("this.user", this.user);
            console.log("this.real_user", this.real_user);
          }
          else {
            if (check == 1)
              this.presentAlert("Erreur", "Vous n'avez pas les droits requis pour vous connecter a EarthencyPro")
            else {
              // this.presentAlert("Erreur", "Vous n'avez pas les droits requis pour vous connecter")
              this.checkCredentials();
            }
          }

        } else {
          this.checkCredentials();
          // this.authService.setLoggedIn(false);
          // this.authService.setUser(null);
          // this.router.navigate(["/welcome"]);
          // this.isAuthenticated = false;
          // this.menu.enable(false);
        }
      }, err => {
        this.authService.setLoggedIn(false);
        this.authService.setUser(null);
        this.router.navigate(["/welcome"]);
        this.isAuthenticated = false;
        this.menu.enable(false);
      }, () => {
        console.log("this.splashScreen.hide()");
      })
    });
  }


  async checkCredentials() {
    let credentials = await this.authService.getCredentials();
    console.log("checkCredentials", credentials);
    if (credentials != null) {
      this.authService.doLogin(credentials);
    }
    else {

      this.authService.setLoggedIn(false);
      this.authService.setUser(null);
      this.router.navigate(["/welcome"]);
      this.isAuthenticated = false;
      this.menu.enable(false);

    }
  }
  selectCommune() {

  }
  ngOnInit() {
    const path = window.location.pathname.split('folder/')[1];
    if (path !== undefined) {
      this.selectedIndex = this.appPages.findIndex(page => page.title.toLowerCase() === path.toLowerCase());
    }
    console.log("prepare");
    setTimeout(() => {
      if (this.electronRef) {
        this.electronRef.initNotifications();

        this.electronRef.initBadge();
      }
    }, 5000);
  }

  async presentAlert(title, message) {
    const alert = await this.alertCtrl.create({
      header: title,
      message: message,
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });
    await alert.present();
  }
}
